import React from 'react';
import PropTypes from 'prop-types';
import clsx from '@strava/ui/clsx';
import styles from './media-body.scss';

const MediaBody = ({ children, className, centerVertically, ...options }) => (
  <div
    className={clsx(
      styles.mediaBody,
      className,
      centerVertically && styles.centerVertically
    )}
    {...options}
  >
    {children}
  </div>
);

MediaBody.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  centerVertically: PropTypes.bool
};

MediaBody.defaultProps = {
  className: null,
  centerVertically: false
};

export default MediaBody;
